/* R44 PERFORMANCE - SKU search for the header search bar and the search results page.
   Shopify's own search index misses some SKUs (all-number part numbers like 522426, and others such as SQ-013),
   so this file keeps its own SKU list, built straight from the catalogue:
     /collections/all?view=sku-index  (templates/collection.sku-index.liquid, 250 products per page)
   The list loads the first time someone uses a search box, then is kept in the browser for 6 hours.
   - Header search: products whose SKU matches what was typed are added to the top of the results
     (rows come from /products/<handle>?view=sku-hit, templates/product.sku-hit.liquid).
   - Search results page: an exact SKU with no Shopify results goes straight to that product; otherwise the
     matching products are shown above the results.
   - Homepage search: an exact SKU for an out-of-stock product switches it from "In stock" to all products.
   Matching ignores capitals, spaces, dashes, dots etc. Exact SKUs match from 3 characters; if the search contains a
   number, SKUs starting with it match from 5 characters. */
(function () {
  if (window.R44Sku) return;
  var TTL = 6 * 3600 * 1000, KEY = 'sku-index:v1', MAX_HITS = 6;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PREVIEW = (location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1];
  function withPreview(u) { return PREVIEW ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + PREVIEW : u; }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ''); }

  var map = null, keys = null, loading = null, listeners = [];

  /* ---------- browser cache (IndexedDB) ---------- */
  var dbp = null;
  function db() {
    return dbp || (dbp = new Promise(function (res) {
      setTimeout(function () { res(null); }, 2000); // never let a stuck browser database hold up the search
      try {
        var r = indexedDB.open('r44-sku-index', 1);
        r.onupgradeneeded = function () { r.result.createObjectStore('feeds'); };
        r.onsuccess = function () { res(r.result); };
        r.onerror = function () { res(null); };
      } catch (e) { res(null); }
    }));
  }
  function cacheGet() {
    return db().then(function (d) {
      if (!d) return null;
      return new Promise(function (res) {
        try {
          var g = d.transaction('feeds', 'readonly').objectStore('feeds').get(KEY);
          g.onsuccess = function () { var v = g.result; res(v && Date.now() - v.t < TTL && v.items && v.items.length ? v : null); };
          g.onerror = function () { res(null); };
        } catch (e) { res(null); }
      });
    });
  }
  function cachePut(items) {
    db().then(function (d) { if (d) try { d.transaction('feeds', 'readwrite').objectStore('feeds').put({ t: Date.now(), items: items }, KEY); } catch (e) {} });
  }

  /* ---------- loading the SKU list ---------- */
  function getPage(n) {
    var url = withPreview(ROOT + 'collections/all?view=sku-index&sort_by=created-ascending&page=' + n);
    var tries = 0;
    function go() { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).catch(function (e) { if (++tries < 3) return new Promise(function (r) { setTimeout(r, 600 * tries); }).then(go); throw e; }); }
    return go();
  }
  function fetchAll() {
    return getPage(1).then(function (first) {
      var pages = [first.items || []], todo = [];
      for (var p = 2; p <= first.pages; p++) todo.push(p);
      function worker() {
        var p = todo.shift();
        if (!p) return Promise.resolve();
        return getPage(p).then(function (j) { pages[p - 1] = j.items || []; }).then(worker);
      }
      var w = []; for (var i = 0; i < 6; i++) w.push(worker());
      return Promise.all(w).then(function () { var all = []; pages.forEach(function (x) { if (x) all = all.concat(x); }); return all; });
    });
  }
  function build(items) {
    var m = new Map();
    items.forEach(function (it) {
      String(it[1] || '').split('|').forEach(function (e) {
        var i = e.lastIndexOf('~'); if (i < 1) return;
        var sku = e.slice(0, i), n = norm(sku); if (!n) return;
        var a = m.get(n); if (!a) m.set(n, a = []);
        a.push([it[0], e.slice(i + 1), sku]);
      });
    });
    map = m; keys = Array.from(m.keys());
  }
  function load() {
    if (map) return Promise.resolve();
    if (loading) return loading;
    loading = cacheGet().then(function (c) {
      if (c) { build(c.items); return; }
      return fetchAll().then(function (items) { build(items); cachePut(items); });
    }).then(function () { listeners.forEach(function (f) { try { f(); } catch (e) {} }); }, function () { loading = null; });
    return loading;
  }

  /* ---------- matching ---------- */
  function find(q) {
    if (!map) return [];
    var n = norm(q); if (n.length < 3) return [];
    var out = [], seen = {};
    function add(arr, exact) { arr.forEach(function (x) { if (seen[x[0]]) return; seen[x[0]] = 1; out.push({ handle: x[0], variant: x[1], sku: x[2], exact: exact }); }); }
    var ex = map.get(n); if (ex) add(ex, true);
    if (n.length >= 5 && /\d/.test(n)) {
      for (var i = 0; i < keys.length && out.length < MAX_HITS * 2; i++) { var k = keys[i]; if (k !== n && k.lastIndexOf(n, 0) === 0) add(map.get(k), false); }
    }
    return out.slice(0, MAX_HITS);
  }
  function lookup(q, waitMs) {
    if (map) return Promise.resolve(find(q));
    if (norm(q).length < 3) return Promise.resolve([]);
    var p = load().then(function () { return find(q); });
    if (!waitMs) return p;
    return Promise.race([p, new Promise(function (r) { setTimeout(function () { r(find(q)); }, waitMs); })]);
  }
  function rowUrl(h) { return withPreview(ROOT + 'products/' + encodeURIComponent(h.handle) + '?view=sku-hit&variant=' + h.variant); }
  function rows(hits, signal) {
    return Promise.all(hits.map(function (h) {
      return fetch(rowUrl(h), { credentials: 'same-origin', signal: signal }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (list) { return list.join(''); });
  }
  function handleOf(href) { var m = String(href || '').match(/\/products\/([^?#\/]+)/); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; } }

  /* ---------- header search (Focal predictive-search-drawer) ---------- */
  function merge(res, hits, signal) {
    var box = document.createElement('div'); box.innerHTML = res.html || '';
    var ul = box.querySelector('ul[data-type="products"]'), present = {};
    if (ul) Array.prototype.forEach.call(ul.querySelectorAll('li'), function (li) { var a = li.querySelector('a[href]'); if (a) present[handleOf(a.getAttribute('href'))] = li; });
    var need = hits.filter(function (h) { return !present[h.handle]; });
    return rows(need, signal).then(function (html) {
      if (signal && signal.aborted) { var err = new Error('aborted'); err.name = 'AbortError'; throw err; }
      if (!ul) {
        if (!html.trim()) return res;
        box.innerHTML = '<div class="predictive-search__results-categories"><div class="predictive-search__results-categories-item" id="predictive-search-products"><input type="hidden" form="predictive-search-form" name="type" value="product"><ul class="predictive-search__product-list list--unstyled" role="list" data-type="products"></ul></div></div>';
        ul = box.querySelector('ul');
      }
      // Exact SKU matches that Shopify already returned move to the top; the rest go in above Shopify's results
      hits.slice().reverse().forEach(function (h) { if (h.exact && present[h.handle]) ul.insertBefore(present[h.handle], ul.firstChild); });
      if (html) ul.insertAdjacentHTML('afterbegin', html);
      return { hasResults: true, html: box.innerHTML };
    });
  }
  function patchDrawer(C) {
    if (!C || C.prototype.__r44sku) return;
    C.prototype.__r44sku = true;
    ['_doPredictiveSearch', '_doLiquidSearch'].forEach(function (name) {
      var orig = C.prototype[name]; if (typeof orig !== 'function') return;
      C.prototype[name] = function (term) {
        var self = this, signal = this.abortController && this.abortController.signal;
        return Promise.all([orig.call(this, term), lookup(term, 1500)]).then(function (r) {
          return r[1].length ? merge(r[0], r[1], signal) : r[0];
        });
      };
    });
  }
  if (window.customElements) {
    var C = customElements.get('predictive-search-drawer');
    if (C) patchDrawer(C); else customElements.whenDefined('predictive-search-drawer').then(function () { patchDrawer(customElements.get('predictive-search-drawer')); });
  }
  // When the list finishes loading after a search was already shown, run that search again so SKU matches appear
  listeners.push(function () {
    document.querySelectorAll('predictive-search-drawer').forEach(function (d) {
      var input = d.querySelector('[name="q"]');
      if (input && input.value.trim() && find(input.value).length) input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    });
  });
  // Start loading as soon as someone heads for a search box
  document.addEventListener('focusin', function (e) { var t = e.target; if (t && t.matches && t.matches('input[name="q"], [data-iss-input], input[type="search"]')) load(); });

  /* ---------- search results page ---------- */
  function searchPage() {
    var sec = document.querySelector('.shopify-section--main-search'); if (!sec) return;
    var q = new URLSearchParams(location.search).get('q') || '';
    if (norm(q).length < 3) return;
    // Product results Shopify found on this page (0 = none)
    var count = sec.querySelectorAll('.product-item').length;
    var box = document.createElement('div'); box.className = 'container'; box.setAttribute('data-r44-sku-hits', ''); box.hidden = true;
    var head = sec.querySelector('.page-header');
    if (head) head.parentNode.insertBefore(box, head.nextSibling); else sec.insertBefore(box, sec.firstChild);
    if (!document.getElementById('r44-sku-hits-css')) {
      var st = document.createElement('style'); st.id = 'r44-sku-hits-css';
      st.textContent = '.r44-sku-hits{margin:24px 0 0;padding:6px 20px 8px;border:1px solid rgba(var(--text-color,0,0,0),.15)}' +
        '.r44-sku-hits__title{margin:12px 0 4px}.r44-sku-hits__note{margin:12px 0;opacity:.7}.r44-sku-hits .predictive-search__product-item{padding:12px 0;border-top:1px solid rgba(var(--text-color,0,0,0),.1)}' +
        '.r44-sku-hits .predictive-search__product-item:first-child{border-top:0}.r44-sku-hit__sku{display:block;margin-top:2px}';
      document.head.appendChild(st);
    }
    if (!map && count === 0) { box.hidden = false; box.innerHTML = '<div class="r44-sku-hits"><p class="r44-sku-hits__note text--small">Checking part numbers&hellip;</p></div>'; }
    load().then(function () {
      var hits = find(q);
      if (!hits.length) { box.hidden = true; box.innerHTML = ''; return; }
      var exact = hits.filter(function (h) { return h.exact; });
      var handles = {}; exact.forEach(function (h) { handles[h.handle] = 1; });
      if (count === 0 && exact.length && Object.keys(handles).length === 1) {
        location.replace(withPreview(ROOT + 'products/' + encodeURIComponent(exact[0].handle) + '?variant=' + exact[0].variant));
        return;
      }
      rows(hits).then(function (html) {
        if (!html.trim()) { box.hidden = true; return; }
        box.innerHTML = '<div class="r44-sku-hits"><p class="r44-sku-hits__title heading heading--small">' + (exact.length ? 'Part number match' : 'Matching part numbers') + '</p>' +
          '<ul class="predictive-search__product-list list--unstyled" role="list">' + html + '</ul></div>';
        box.hidden = false;
      });
    });
  }
  /* ---------- homepage product search (assets/r44-product-search.js) ----------
     It opens on the "In stock" tab. If a typed SKU belongs to a product that isn't in stock, switch to the
     "Available products" tab so the part still shows. */
  function homeSearch() {
    document.querySelectorAll('[data-iss]').forEach(function (el) {
      if (el.__r44sku) return; el.__r44sku = true;
      var input = el.querySelector('[data-iss-input]'), track = el.querySelector('[data-iss-track]');
      if (!input || !track || !window.MutationObserver) return;
      new MutationObserver(function () {
        var sw = track.querySelector('[data-iss-switch="all"]'); if (!sw) return;
        var q = input.value;
        lookup(q).then(function (hits) {
          if (input.value === q && track.contains(sw) && hits.some(function (h) { return h.exact; })) sw.click();
        });
      }).observe(track, { childList: true });
    });
  }
  function start() { searchPage(); homeSearch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', homeSearch);

  window.R44Sku = { load: load, find: find, lookup: lookup, norm: norm };
})();
